/** Leading-edge debounce (matches legacy siema usage: fn takes no args from timer). */
export default function debounce(func: () => void, wait: number): () => void {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func();
    }, wait);
  };
}
